import {SET_CONTRAST} from '../constants/ActionTypes';

const initialState = {
    contrast: 'normal'
};

export default function contrast(state = initialState, action) {
    switch (action.type) {
        case SET_CONTRAST:
            return {
                ...state,
                contrast: action.contrast
            };
        default:
          return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/contrast.js